export const CompanyRuleEN = {
    "companyRule": {
        "title":{
            "header":"Company rules"
        },
        "label": {
            "name": "Name",
            "amount": "Money amount"
        }
    }
}